import imageCompression from "browser-image-compression";

/**
 * Compress an image file before uploading.
 * @param {File} file - Original image file.
 * @param {Object} options - Optional settings (default is max 0.5MB, 1080px).
 * @returns {Promise<File>} - Compressed image file.
 */
export const compressImage = async (file, options = {}) => {
  const defaultOptions = {
    // maxSizeMB: 0.5, // max size is half MB.
    initialQuality: 0.7,
    maxWidthOrHeight: 1080,
    useWebWorker: true,
  };

  if (file.size < 150 * 1024) {
    return file; // skip compression under 150 KB
  }

  try {
    const compressed = await imageCompression(file, {
      ...defaultOptions,
      ...options,
    });

    return compressed;
  } catch (err) {
    throw err;
  }
};
